import { request } from "../fetch";

class AgendaService {
    static async getEspecialidadesPorClinica(clinicaId) {
        return request(`api/adm/especialidades/clinica/${clinicaId}`);
    }
    static async getFormasPagamentoPorClinica(clinicaId) {
        return request(`api/financas/formapagamento/clinica/${clinicaId}`);
    }
    static async getClinicasFiliais() {
        return request(`api/adm/clinicas/com-filiais`);
    }
    static async getLinkAgendamentoOnline(clinicaId) {
        return request(`api/agendamento/link-agendamento-online?clinica=${clinicaId}`);
    }
    static async confirmarAgendamentoOnline(data) {
        return request(`api/agendamento/agendamento-online`, {
            method: 'POST',
            body: JSON.stringify(data),
        });
    }
    static async getConfigAgendamentoOnline(clinicaId) {
        return request(`api/adm/clinicas/${clinicaId}/config-agendamento-online`);
    }
    static async updateConfigAgendamentoOnline(clinicaId, data) {
        return request(`api/adm/clinicas/${clinicaId}/config-agendamento-online`, {
            method: 'PUT',
            body: JSON.stringify(data),
        });
    }
    static async getAgendamentosByMonth(clinicaId, year, month) {
        return request(`api/agendamento/clinica/${clinicaId}/month/${year}/${month}`);
    }
    static async verificarRequisitosAgendamento({ clinicaId }) {
        const qs = new URLSearchParams({ clinicaId });
        return request(`api/agendamento/verificar-requisitos?${qs.toString()}`);
    }
}

export { AgendaService };